<template>
  <div class="y_main">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        账期列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting(1)">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" class="content_box">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="mobile" width="120" label="账号" align="center"></el-table-column>

        <el-table-column prop="bind_mobile" width="120" label="绑定手机号" align="center"></el-table-column>

        <el-table-column prop="email" width="170" label="邮箱" align="center"></el-table-column>

        <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>

        <el-table-column prop="create_date" width="150" label="注册时间" align="center"></el-table-column>

        <el-table-column label="消费金额" align="center" prop="pay_sum_money"></el-table-column>

        <el-table-column prop="identity" label="身份" align="center"></el-table-column>

        <el-table-column label="操作" width="180" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="red(scope.row.mobile)" class="button1">查看详情</button>
            <button  class="button1">关闭主账户</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_box clearfix">
        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="15"
            :current-page.sync="page"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
import "../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      select: false,
      selectAll: false
    };
  },
  created() {
    this.$store.state.leftTitle = "主账户功能";
    this.$store.state.topActiveId = 4;
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    shipments(id) {
      //确认发货弹窗
      const _this = this;
      this.axios
        .get(this.serve + "/admin/express_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          _this.option = [];
          var json = res.data.data.results;
          _this.id = id;
          for (var key in json) {
            if (json[key].status == "1") {
              _this.option.push(json[key]);
            }
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("添加失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "添加成功",
        type: "success"
      });
    },
    submit(id) {
      //弹窗提交

      for (var key in this.tableData) {
        if (this.odd === this.tableData[key].mobile) {
          this.$message.error("此账号已存在");
          return;
        }
      }
      if (this.odd == "") {
        this.$message.error("请输入用户账号");
        return;
      } else if (this.odd !== "") {
        var cel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!cel.test(this.odd)) {
          this.$message.error("账号为手机号码");
          return;
        }
      }
      if (this.password == "") {
        this.$message.error("请输入密码");
        return;
      } else if (this.password !== "") {
        var pass = /^[A-Za-z0-9]{6,20}$/;
        if (!pass.test(this.password)) {
          this.$message.error("登陆密码最小为6位数，最大为20位数");
          return;
        }
      }
      if (this.password1 != this.password) {
        this.$message.error("两次输入密码不一致");

        return;
      }
      if (this.odd || this.password || this.password1) {
        this.dialogFormVisible1 = false;
      }
      const _this = this;

      this.axios
        .get(this.serve + "/admin/create_home_user", {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.odd,
            password: this.password,
            new_pass: this.password1
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            _this.open();
            _this.geting();
          } else if (res.data.status == "error") {
            _this.open4();
          }
        });
    },
    red(id) {
      this.$router.push({
        path: "y_mainLook/" + id
      });
    },
    set(id) {
      this.$router.push({
        path: "y_exchangeLook/" + id
      });
    },
    del(id, status1) {
      if (status1 == "确认发货") {
        this.dialogFormVisible1 = false;
      }
      if (status1 == "订单跟踪") {
        this.$router.push({
          path: "d_orderTail?id=" + id
        });
      }
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/host_user_list", {
          params: {
            token: this.token,
            username: this.username,
            page: page
          }
        })
        .then(res => {
          that.tableData = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            this.total = json.total;
            this.page = json.page;
            for (var key in json.results) {
              this.tableData.push(json.results[key]);
              var time = json.results[key].create_date;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].create_date = timeNew;
            }
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.y_main {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>